import { TFunction } from 'i18next';
import { AxiosError } from 'axios';

import { ErrorInputState } from './index';
import { ACH_ERROR_MSG, GiftCard } from 'services/checkout-service/models';

export const isValid = (fieldState: ErrorInputState): boolean => {
  return !fieldState.hasError;
};

export const isTouchedAndValid = (fieldState: ErrorInputState): boolean => {
  return fieldState.isTouched && !fieldState.hasError;
};

export const getApiErrorMessage = (error: AxiosError, t: TFunction) => {
  if (error?.response?.data?.status?.failureMessage) {
    const { failureMessage } = error.response?.data.status;
    const achErrMsg = failureMessage.replace(/[^a-z]/gi, '') as keyof typeof ACH_ERROR_MSG;
    const errorMessageKey = ACH_ERROR_MSG[achErrMsg];
    if (errorMessageKey) {
      return t(`common:ach.errors.${errorMessageKey}`);
    }
  }

  return '';
};

export function calculateFinalGiftCardAmount(giftCards: GiftCard[], total: number) {
  let finalGiftCardAmount = total;

  // if only one gift card, no need to compute just return total
  if (giftCards.length === 1) return finalGiftCardAmount;

  // iterate through all gift cards EXCEPT final one
  for (let i = 0; i < giftCards.length; i++) {
    if (i !== giftCards.length - 1) {
      finalGiftCardAmount -= giftCards[i].balance;
    }
  }

  return finalGiftCardAmount;
}
